export const statusDescription = [
    'Completed',
    'Watchlist'
]
  
export const genreDescription = [
    'Action',
    'Comedy',
    'Drama',
    'Horror',
    'Sci Fi',
    'Fantasy',
    'Romance',
    'Thriller'
]